import React from 'react'

const SignatureLogoColumn = ({contactInfo, disclaimer, logo, sharedStyles}) => {

    const styles = {
        padding: sharedStyles.padding15,
        height12: sharedStyles.height12,
        height24: sharedStyles.height24,
        logo: {
            boxSizing:'border-box',
            borderStyle: 'none',
            width:'100px'
        },
        paddingBorder: {
            padding: '0 0 0 15px',
            borderLeft: '3px solid #F6B000'
        },
        name: sharedStyles.headingStyle,
        subText: sharedStyles.pStyle,
        inlineBlock: {
            display: 'inline-block'
        },
        url: sharedStyles.urlStyle,
        disclaimer: sharedStyles.disclaimer
    }
    
    return(
        <div className="signatureBlock" id="twoColumnsSignature">
            <table border="0" cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr>
                        <td>
                            <table border="0" cellPadding="0" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        {!!(logo) &&
                                            <td bgcolor="#013C65" style={styles.padding} width="100px">
                                                <table border="0" cellPadding="0" cellSpacing="0">
                                                    <tbody>
                                                        <tr>
                                                            <td height="12" style={styles.height12}></td> 
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                
                                                                <img src={logo.src} width="100" style={styles.logo} alt={logo.alt} />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td height="12" style={styles.height12}></td> 
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        }
                                        <td style={styles.paddingBorder}>
                                            <table border="0" cellPadding="0" cellSpacing="0" width="300">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className="name">
                                                                <p style={styles.name}><strong>
                                                                    {contactInfo.name}
                                                                    </strong></p>
                                                                { contactInfo.pronouns && 
                                                                    <p style={styles.subText}>Pronouns: {contactInfo.pronouns}</p>
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td height="12" style={styles.height12}></td> 
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="title-department">
                                                                <p style={styles.subText}>
                                                                    { contactInfo.title &&
                                                                        <>{contactInfo.title}</>
                                                                    }
                                                                    { contactInfo.title && contactInfo.department &&
                                                                    <br />
                                                                    }
                                                                    { contactInfo.department &&
                                                                        <>{contactInfo.department}</>
                                                                    }            
                                                                    </p>                                                        
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td height="12" style={styles.height12}></td> 
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="title-department">
                                                                <p style={styles.subText}><strong>University of Northern Colorado</strong><br />
                                                                    { contactInfo.building &&
                                                                        <>{contactInfo.building}<br /></>
                                                                    }
                                                                    {contactInfo.address &&
                                                                    <>{contactInfo.address},</> 
                                                                    }
                                                                    {contactInfo.campusbox &&
                                                                        <> Campus Box {contactInfo.campusbox}</>
                                                                    }                                                                    
                                                                    {contactInfo.city &&
                                                                    <><br />
                                                                    {contactInfo.city}</>
                                                                    }
                                                                </p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td height="12" style={styles.height12}></td> 
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="contact-info">
                                                                <p style={styles.subText}>
                                                                
                                                                {!!(contactInfo.phoneoffice) &&
                                                                    <span className="no-break" style={styles.inlineBlock}>
                                                                        O: <a href={"tel:" + contactInfo.phoneoffice} style={styles.url}>{contactInfo.phoneoffice}</a>
                                                                    </span> 
                                                                }
                                                                
                                                                {!!(contactInfo.phonecell) &&
                                                                    <span className="no-break" style={styles.inlineBlock}>
                                                                        &nbsp;| C: <a href={"tel:" + contactInfo.phonecell} style={styles.url}>{contactInfo.phonecell} </a>
                                                                    </span> 
                                                                }

                                                                {!!(contactInfo.phonefax) &&
                                                                    <span className="no-break" style={styles.inlineBlock}>
                                                                        &nbsp;| F: {contactInfo.phonefax}
                                                                    </span>
                                                                }
                                                                </p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td height="12" style={styles.height12}></td> 
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="contact-info">
                                                                <p style={styles.subText}><a href={contactInfo.url} style={styles.url}>{contactInfo.url}</a></p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td height="12" style={styles.height12}></td> 
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    {!!(disclaimer) &&
                        <tr>
                            <td>
                                <table border="0" cellPadding="0" cellSpacing="0">
                                    <tbody>
                                        <tr>
                                            <td height="24" style={styles.height24}></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">
                                                <p className="disclaimer" style={styles.disclaimer}>
                                                    {disclaimer}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="24" style={styles.height24}></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default SignatureLogoColumn;